const userTypes = {
  System: { id: 1, name: "system" },
  Administrator: { id: 2, name: "administrator" },
  Professor: { id: 3, name: "professor" },
  Advanced_Student: { id: 4, name: "advanced" },
  Basic_Student: { id: 5, name: "basic" }
};

export { userTypes };
